'use server';

import { cookies } from 'next/headers';
import { revalidatePath } from 'next/cache';
import { isLocale } from '@/i18n/config';
import { apiRequest } from '@/lib/api-client';
import { getToken } from '@/lib/auth';
import { rememberLocale } from '@/lib/i18n/locale-cookie';

export const setLocale = async (locale: string) => {
  if (!isLocale(locale)) return;
  rememberLocale(await cookies(), locale);
  // Signed in: the account keeps it too — the next sign-in, on any browser, and the account
  // e-mails use it. Best effort: the picker works on this browser whatever the CMS says.
  const token = await getToken();
  if (token)
    await apiRequest('/api/users/me/language', { method: 'PATCH', token, body: { language: locale } }).catch(() => null);
  // Every page renders text on the server, so all of them have to be drawn again.
  revalidatePath('/', 'layout');
};
